// import ArticlesBannerB from '@components/BannerAds/ArticlesBannerB';
// import ArticlesBannerC from '@components/BannerAds/ArticlesBannerC';
import Layout from '@components/Layout';
import MostViewPostGroup from '@components/PostGroupCategory/MostViewPostGroupPageCategory';
import PostItem from '@components/PostItem/LargePostItem';
import SEO from '@components/seo';
import SEOPrevNextHelmet from '@components/SEOPrevNextHelmet';
import VnrLink from '@components/VnrLink';
import Zone from '@components/Zone';
import { Card, Col, Pagination, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { DOMAIN } from 'src/constants';
import useLessonSeenState from 'src/hook/useLessonSeenState';

import containerStyles from '../../../pages/HomePageStyle.module.scss';
import style from './TopicalGroup.module.scss';

const checkRootTopic = (topicTree, isTopicPage, topicSlug) => {
  if (!isTopicPage) {
    return [];
  }

  const cryptoTopic = topicTree.slice(0, 2).some((item) => item.treeData.includes(topicSlug));
  const forexTopic = topicTree.slice(3, 5).some((item) => item.treeData.includes(topicSlug));

  if (cryptoTopic) {
    return [
      {
        name: 'Crypto Topic',
        url: 'crypto-topic',
      },
    ];
  }

  if (forexTopic) {
    return [
      {
        name: 'Forex Topic',
        url: 'special-topic',
      },
    ];
  }

  return [];
};

const TopicGroup = ({
  data,
  pageContext,
  pageNextJs,
  newSlickBrokers,
  newMostViewPosts,
  breadcrumbPageCategory,
  breadcrumbPageTopic,
  posts = [],
  topicTree,
  isTopicPage = false,
  featurePostGroups,
}) => {
  const topicGroupData = {
    name: data.title.rendered,
    link: data.acf.path,
  };
  const postList = pageContext?.posts || posts;

  const dataForexSectionB =
    topicTree?.find((item) => item.code === 'phan-tich-va-giao-dich-forex') || {};

  const [seenPercentage, setSeenPercentage] = useState();
  const { getLessonSeenState } = useLessonSeenState();

  const isTopticCongCuDauTuVang = pageNextJs?.originalId === 36408 ? true : false;
  const isAnalysisTopic = dataForexSectionB?.treeData?.includes(`"id":${pageNextJs?.originalId}`);

  const breadCrumbRootTopic = checkRootTopic(topicTree, isTopicPage, pageNextJs.url);
  const breadcrumbTopic = breadCrumbRootTopic.concat(breadcrumbPageTopic);
  const breadcrumbPage = breadcrumbPageCategory || breadcrumbTopic;

  let topicPageMetaDescription = null;
  if (isTopicPage) {
    if (isAnalysisTopic) {
      topicPageMetaDescription = `VnRebates cung cấp những phân tích về ${topicGroupData.name} từ nhiều chuyên gia uy tín, cho bạn cái nhìn chính xác nhất về thị trường Forex để phục vụ trading hiệu quả`;
    } else {
      topicPageMetaDescription = `VnRebates cung cấp các kiến thức về ${topicGroupData.name} đã được chắt lọc, hệ thống hoá và quan trọng là đã tự kiểm nghiệm hiệu quả, làm hành trang cho các Trader Newbie lẫn Pro`;
    }
  }

  if (isTopticCongCuDauTuVang) {
    topicPageMetaDescription =
      'VnRebates cung cấp các kiến thức về Đầu tư vàng đã được chắt lọc, hệ thống hoá và quan trọng là đã tự kiểm nghiệm hiệu quả, làm hành trang cho các Trader Newbie lẫn Pro';
  }

  if (pageNextJs?.url === 'ty-gia-yen-nhat') {
    topicPageMetaDescription =
      'VnRebates cập nhật tỷ giá Yên Nhật mới nhất, cung cấp thông tin giá trị để hỗ trợ quyết định đầu tư hiệu quả và chính xác. Xem ngay để biết thêm!';
  }

  const renderPostItem = (item, index) => {
    if (!item) {
      return null;
    }
    return (
      <PostItem
        isShowProgessBar
        post={item}
        key={item.id}
        seenPercentage={seenPercentage ? seenPercentage[item.id] : 0}
        indexTopic={breadcrumbPageTopic && index}
      />
    );
  };

  const getPath = (url, index) => {
    const pathIndex = url.indexOf('/trang/');
    if (pathIndex === -1) {
      return `${url}/trang/${index}`;
    }
    return `${url.substring(0, pathIndex)}/trang/${index}`;
  };

  const paginationSetting = {
    showTitle: false,
    defaultPageSize: 1,
    pageSize: 1,
    total: pageContext?.numberOfPages,
    current: pageContext?.currentPage,
    onChange: () => {},
    showSizeChanger: false,
    showQuickJumper: false,
    itemRender: (current, type, element) => {
      if (type === 'page') {
        return <VnrLink to={getPath(pageNextJs.url, current)}>{current}</VnrLink>;
      }
      if (type === 'prev' && current !== 0) {
        return (
          <VnrLink
            to={getPath(pageNextJs.url, current)}
            className={style['ant-pagination-item-link']}
          >
            &#171;
          </VnrLink>
        );
      }
      if (type === 'next' && current !== pageContext?.numberOfPages) {
        return (
          <VnrLink
            to={getPath(pageNextJs.url, current)}
            className={style['ant-pagination-item-link']}
          >
            &#187;
          </VnrLink>
        );
      }
      return element;
    },
  };

  const getCanonical = (data) => {
    if (data.acf.path) {
      return data.acf.path;
    }
    if (data.acf.path_page) {
      return data.acf.path_page;
    }
  };
  const topicGroupPaginationSEO = {
    numberOfPages: pageContext?.numberOfPages,
    currentPage: pageContext?.currentPage,
    canonicalPage: getCanonical(data),
    prevPath: '/' + getPath(pageNextJs.url, pageContext?.currentPage - 1),
    nextPath: '/' + getPath(pageNextJs.url, pageContext?.currentPage + 1),
  };

  const removeFakeLcp = () => {
    const element = document.getElementById('websiteName');

    if (!element) return;
    element.remove();
  };

  useEffect(() => {
    const percentageTmp = {};
    postList.forEach((post) => {
      percentageTmp[post.id] = getLessonSeenState(post.id);
    });
    setSeenPercentage(percentageTmp);
  }, [pageNextJs.originalId]);

  useEffect(() => {
    if (typeof window === undefined) {
      return;
    }

    setTimeout(() => {
      removeFakeLcp();
    }, 1000);
  }, [pageNextJs.originalId]);

  const isAirdropCate = pageNextJs.url === "airdrop-tai-vnrebates";
  return (
    <Layout
      breadcrumbPageTopic={isTopicPage ? breadcrumbTopic : null}
      breadcrumbPageCategory={breadcrumbPageCategory}
      brokers={newSlickBrokers}
      haveAds
      featurePostGroups={featurePostGroups}
    >
      <SEO
        canonical={`${DOMAIN}${getCanonical(data)}`}
        title={data?.acf?.meta_title || data.acf.name || topicGroupData.name}
        description={data?.acf?.description || topicPageMetaDescription}
      />
      <SEOPrevNextHelmet data={topicGroupPaginationSEO} />
      <Row className={`${style['vnr-page-topic-group']} ${containerStyles.insideContent}`}>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 17 }}
          lg={{ span: 17 }}
          className={style.postItemList}
        >
          <Zone style={{ boxShadow: 'none', padding: 0 }}>
            <Card style={{ width: '100%', padding: 0, border: 0 }}>
              <div style={{ width: '100%', padding: 0 }}>
              {isAirdropCate &&<div>

                  <div className={style.airdropTite}>Airdrop là gì?
                  </div>
                  <p>Airdrop tại VnRebates là chuỗi chương trình đặc biệt mang lại giá trị thực cho các bạn thành viên trên con đường trading của mình. Thông qua chương trình, bạn sẽ có thể:
                  </p>
                  <ul className={style.airdropBenefit}>
                    <li>Trải nghiệm đa dạng khi mở tài khoản mới tại các sàn forex uy tín.</li>
                    <li>Chọn được sàn phù hợp nhất từ top sàn giao dịch forex có giấy phép quốc tế.</li>
                    <li>Nhận các giải thưởng tiền mặt cực hấp dẫn.</li>
                  </ul>
                  <p>Đã có hơn 100 người tham gia và tiếp tục quay lại để làm airdrop vì sự hấp dẫn của chương trình này.</p>
                  <p>Chương trình sẽ diễn ra hàng tháng, các bạn nhớ theo dõi để đón xem thông tin mới tại website VnRebates và <VnrLink to="https://t.me/vnrebates" style={{ color: '#0872ca', textDecoration: 'underline' }}>Telegram channel</VnrLink></p>
                  </div>}
                <h1
                  dangerouslySetInnerHTML={{ __html: `${data.title.rendered}` }}
                  className={style.categoryTitle}
                ></h1>
                <div id="websiteName" className={style.websiteName}>
                  VNREBATES
                </div>
                <div style={{ marginTop: 15 }} />
                {postList.map((post, index) => renderPostItem(post, index + 1))}
                <div style={{ marginTop: 15 }} />

                {pageContext && <Pagination {...paginationSetting} />}
              </div>
            </Card>
          </Zone>
        </Col>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          md={{ span: 10 }}
          lg={{ span: 7 }}
          className={style.bannerPageCategory}
        >
          {/* <div className={style.articlesBannerB}>
            <ArticlesBannerB />
          </div> */}
          {/* <div className={style.articlesBannerC}>
            <ArticlesBannerC />
          </div> */}
          <div className={style.mostViewPosts}>
            <MostViewPostGroup title="Tin đọc nhiều" isMore={false} posts={newMostViewPosts} />
          </div>
        </Col>
      </Row>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `
            {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "Trang chủ",
              "item": "${DOMAIN}"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "${breadcrumbPage[0]?.name}",
              "item": "${DOMAIN + breadcrumbPage[0]?.url}"
            }${
              breadcrumbPage[1]
                ? `,{
              "@type": "ListItem",
              "position": 3,
              "name": "${breadcrumbPage[1]?.name}",
              "item": "${DOMAIN + breadcrumbPage[1]?.url}"
            }`
                : ''
            }]
          }
          `,
        }}
      />
    </Layout>
  );
};

export default TopicGroup;
